import { render } from "./PaperModalCustom.vue?vue&type=template&id=731d186c"
import script from "./PaperModalCustom.vue?vue&type=script&lang=js"
export * from "./PaperModalCustom.vue?vue&type=script&lang=js"

import "./PaperModalCustom.vue?vue&type=style&index=0&id=731d186c&lang=less"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__